/* Everpetal — theme behaviour.
   Gallery, quantity-break widget, sticky bar, and the AJAX cart drawer. No
   dependencies. With JavaScript off the page still works: first slide visible,
   quantity 1 in the form, buy button is a real submit that lands on /cart. */
(function () {
  'use strict';

  var routes = window.EverpetalRoutes || { cart: '/cart', add: '/cart/add.js', change: '/cart/change.js', root: '/' };
  var money = function (cents) {
    var fmt = window.EverpetalMoneyFormat || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };

  /* ------------------------------------------------------------- gallery -- */
  function initGallery(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.gallery__dot'));
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var current = 0;

    function goTo(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(index) {
      if (index === current) return;
      current = index;
      thumbs.forEach(function (t, i) { t.setAttribute('aria-selected', i === index ? 'true' : 'false'); t.tabIndex = i === index ? 0 : -1; });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      var active = thumbs[index];
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      slides.forEach(function (slide, i) {
        var v = slide.querySelector('video');
        if (v) { if (i === index) v.play().catch(function () {}); else v.pause(); }
      });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (thumb, i) {
      thumb.tabIndex = i === 0 ? 0 : -1;
      thumb.addEventListener('click', function () { goTo(i); });
      thumb.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % thumbs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + thumbs.length) % thumbs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = thumbs.length - 1;
        if (n === null) return;
        e.preventDefault(); goTo(n); thumbs[n].focus();
      });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    if (prev) prev.disabled = true;
    if (next) next.disabled = slides.length < 2;
  }

  /* --------------------------------------------------------- cart drawer -- */
  var Drawer = {
    el: null, panel: null, lastFocus: null, discount: '',

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el || this.el.dataset.ready) return;
      this.el.dataset.ready = '1';
      this.panel = this.el.querySelector('[data-cart-panel]');
      var self = this;

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
      this.el.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line]');
        if (!line) return;
        var input = line.querySelector('[data-qty-input]');
        if (!input) return;
        var qty = parseInt(input.value, 10) || 0;
        if (e.target.closest('[data-qty-plus]')) self.change(line.dataset.line, qty + 1);
        if (e.target.closest('[data-qty-minus]')) self.change(line.dataset.line, Math.max(0, qty - 1));
        if (e.target.closest('[data-remove]')) self.change(line.dataset.line, 0);
      });
      this.el.addEventListener('click', function (e) {
        var up = e.target.closest('[data-upsell]');
        if (up) self.change(up.dataset.upsellLine, parseInt(up.dataset.qty, 10));
      });
      this.el.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (!input) return;
        var line = input.closest('[data-line]');
        self.change(line.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
      });
      this.el.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-cart-checkout-form]');
        if (form && self.discount) {
          e.preventDefault();
          window.location.href = '/checkout?discount=' + encodeURIComponent(self.discount);
        }
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      var self = this;
      setTimeout(function () { (self.el.querySelector('[data-cart-close]') || self.panel).focus(); }, 60);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    error: function (message) {
      var box = this.el && this.el.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = message;
      box.hidden = false;
      clearTimeout(this._errTimer);
      this._errTimer = setTimeout(function () { box.hidden = true; }, 4500);
    },

    /* Re-render the drawer + header count from the store's own markup so what
       the customer sees is always Shopify's truth, never a local guess. */
    refresh: function () {
      var self = this;
      return fetch(routes.root + '?sections=cart-drawer,header', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (html) {
          if (html['cart-drawer']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html['cart-drawer'];
            var fresh = tmp.querySelector('[data-cart-drawer]');
            if (fresh) {
              var wasOpen = self.el.classList.contains('is-open');
              var panel = fresh.querySelector('[data-cart-panel]');
              self.panel.innerHTML = panel.innerHTML;
              if (wasOpen) self.el.classList.add('is-open');
            }
          }
          if (html.header) {
            var t2 = document.createElement('div');
            t2.innerHTML = html.header;
            var count = t2.querySelector('[data-cart-count]');
            var current = document.querySelector('[data-cart-count]');
            if (count && current) {
              current.textContent = count.textContent;
              current.hidden = count.hidden;
            }
          }
        });
    },

    add: function (formData) {
      var self = this;
      this.el.classList.add('is-busy');
      return fetch(routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          return self.refresh();
        })
        .then(function () { self.open(); })
        .catch(function (err) { self.open(); self.error(err.message); })
        .then(function () { self.el.classList.remove('is-busy'); });
    },

    change: function (line, quantity) {
      var self = this;
      this.el.classList.add('is-busy');
      return fetch(routes.change, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('Could not update cart'); return self.refresh(); })
        .catch(function (err) { self.error(err.message); })
        .then(function () { self.el.classList.remove('is-busy'); });
    }
  };

  /* ------------------------------------------------- quantity-break tiers -- */
  function initTiers(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var tiers = Array.prototype.slice.call(form.querySelectorAll('[data-tier]'));
    var quantityInput = form.querySelector('[data-quantity-input]');
    var atcTotal = document.querySelector('[data-atc-total]');
    var stickyTotal = document.querySelector('[data-sticky-total]');

    function apply(tier) {
      if (quantityInput) quantityInput.value = tier.dataset.qty || '1';
      var total = tier.dataset.total || '';
      if (atcTotal && total) atcTotal.textContent = total;
      if (stickyTotal && total) stickyTotal.textContent = total;
      Drawer.discount = (tier.dataset.discount || '').trim();
    }
    tiers.forEach(function (tier) {
      tier.addEventListener('change', function () { if (tier.checked) apply(tier); });
    });
    var checked = tiers.filter(function (t) { return t.checked; })[0] || tiers[0];
    if (checked) { checked.checked = true; apply(checked); }

    /* AJAX add: the same form the sticky bar submits, so one path for both. */
    form.addEventListener('submit', function (e) {
      if (!Drawer.el || !window.fetch) return;   /* no drawer → normal POST to /cart */
      e.preventDefault();
      var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'))
        .concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + form.getAttribute('id') + '"]')));
      /* form.id is shadowed by the <input name="id"> inside a Shopify product form. */
      buttons.forEach(function (b) { b.classList.add('is-busy'); b.disabled = true; });
      var fd = new FormData(form);
      fd.delete('return_to');
      Drawer.add(fd).then(function () {
        buttons.forEach(function (b) { b.classList.remove('is-busy'); b.disabled = false; });
      });
    });
  }

  /* ---------------------------------------------------------- sticky bar -- */
  function initSticky(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var buybox = document.getElementById('EverpetalBuyBox');
    bar.removeAttribute('hidden');
    if (!buybox || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buybox);
  }

  /* ----------------------------------------------------------- countdown -- */
  function initCountdown(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var deadline = parseInt(el.dataset.deadline, 10) * 1000;
    var d = el.querySelector('[data-cd-days]'), h = el.querySelector('[data-cd-hours]'),
        m = el.querySelector('[data-cd-mins]'), s = el.querySelector('[data-cd-secs]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var left = Math.floor((deadline - Date.now()) / 1000);
      if (left <= 0) { el.remove(); return; }
      d.textContent = Math.floor(left / 86400);
      h.textContent = pad(Math.floor(left % 86400 / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60));
      s.textContent = pad(left % 60);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------------------------------------------------- rating row sync -- */
  function syncRating() {
    var stats = document.querySelector('[data-review-stats]');
    var row = document.querySelector('[data-rating-row]');
    if (!stats || !row) return;
    var count = parseInt(stats.dataset.count, 10) || 0;
    if (!count) return;
    var avg = parseFloat(stats.dataset.avg) || 0;
    var full = Math.round(avg), out = '';
    for (var i = 1; i <= 5; i++) out += i <= full ? '\u2605' : '\u2606';
    var stars = row.querySelector('[data-rating-stars]');
    var text = row.querySelector('[data-rating-text]');
    if (stars) { stars.className = 'stars'; stars.textContent = out; }
    if (text) text.textContent = avg.toFixed(1) + ' \u00b7 ' + count + ' ' + (count === 1 ? stats.dataset.labelOne : stats.dataset.labelMany);
  }

  /* ------------------------------------------------------ viewers count -- */
  function initViewers(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var min = parseInt(el.dataset.min, 10) || 8, max = parseInt(el.dataset.max, 10) || 30;
    var out = el.querySelector('[data-viewers-count]');
    var n = min + Math.floor(Math.random() * (max - min + 1));
    function tick() {
      var step = Math.floor(Math.random() * 5) - 2;
      n = Math.max(min, Math.min(max, n + step));
      out.textContent = n;
      setTimeout(tick, 4000 + Math.random() * 6000);
    }
    tick();
  }

  /* ----------------------------------------------------- compare slider -- */
  function initCompare(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var range = el.querySelector('[data-compare-range]');
    var set = function (v) { el.style.setProperty('--pos', v + '%'); };
    range.addEventListener('input', function () { set(range.value); });
    var drag = function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      var v = Math.max(0, Math.min(100, x / r.width * 100));
      range.value = v; set(v);
    };
    var down = false;
    el.addEventListener('pointerdown', function (e) { down = true; drag(e); });
    window.addEventListener('pointermove', function (e) { if (down) drag(e); });
    window.addEventListener('pointerup', function () { down = false; });
  }

  /* --------------------------------------------------- reviews show more -- */
  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var per = parseInt(root.dataset.perPage, 10) || 6;
    var btn = root.parentElement.querySelector('[data-reviews-more]');
    var count = root.parentElement.querySelector('[data-reviews-count]');
    if (!btn) return;
    var total = root.querySelectorAll('.review').length;
    btn.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(root.querySelectorAll('[data-review-hidden]'));
      hidden.slice(0, per).forEach(function (el) { el.removeAttribute('hidden'); el.removeAttribute('data-review-hidden'); });
      var left = root.querySelectorAll('[data-review-hidden]').length;
      if (count) count.textContent = '(' + (total - left) + '/' + total + ')';
      if (!left) btn.parentElement.remove();
    });
  }

  /* ----------------------------------------------------------- site menu -- */
  function initMenu() {
    var menu = document.querySelector('[data-menu]');
    if (!menu || menu.dataset.ready) return;
    menu.dataset.ready = '1';
    var toggle = document.querySelector('[data-menu-open]');
    function set(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { e.preventDefault(); set(true); }
      if (e.target.closest('[data-menu-close]')) { e.preventDefault(); set(false); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* --------------------------------------------------- lazy video playback -- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initLazyVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('.benefit video, .clip video, .gallery__slide video'));
    if (reduceMotion) { vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }); return; }
    if (!vids.length || !('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.closest('.clip') && v.parentElement.querySelector('[data-clip-toggle]') && v.parentElement.querySelector('[data-clip-toggle]').dataset.userPaused) return; v.muted = true; v.loop = true; v.playsInline = true; if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { rootMargin: '120px 0px', threshold: 0.25 });
    vids.forEach(function (v) { if (!v.dataset.lazyReady) { v.dataset.lazyReady = '1'; io.observe(v); } });
  }

  function initClipToggles() {
    document.querySelectorAll('[data-clip-toggle]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var video = btn.parentElement.querySelector('video');
      if (!video) { btn.remove(); return; }
      function toggle() {
        if (video.paused) { video.play().catch(function () {}); btn.setAttribute('aria-pressed', 'false'); btn.dataset.userPaused = ''; }
        else { video.pause(); btn.setAttribute('aria-pressed', 'true'); btn.dataset.userPaused = '1'; }
      }
      btn.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
    });
  }

  function init() {
    initMenu();
    initLazyVideos();
    initClipToggles();
    Drawer.init();
    document.querySelectorAll('[data-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-viewers]').forEach(initViewers);
    document.querySelectorAll('[data-compare]').forEach(initCompare);
    syncRating();
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
    var gallery = document.querySelector('[data-gallery]');
    if (gallery) initGallery(gallery);
    var form = document.getElementById('everpetal-buy');
    if (form) initTiers(form);
    var bar = document.querySelector('[data-sticky-atc]');
    if (bar) initSticky(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
